/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AtoNDefinitionAlarmSetupInner } from './AtoNDefinitionAlarmSetupInner';
import {
    AtoNDefinitionAlarmSetupInnerFromJSON,
    AtoNDefinitionAlarmSetupInnerFromJSONTyped,
    AtoNDefinitionAlarmSetupInnerToJSON,
} from './AtoNDefinitionAlarmSetupInner';
import type { AtoNDefinitionPosition } from './AtoNDefinitionPosition';
import {
    AtoNDefinitionPositionFromJSON,
    AtoNDefinitionPositionFromJSONTyped,
    AtoNDefinitionPositionToJSON,
} from './AtoNDefinitionPosition';
import type { AtoNDefinitionScheduleInner } from './AtoNDefinitionScheduleInner';
import {
    AtoNDefinitionScheduleInnerFromJSON,
    AtoNDefinitionScheduleInnerFromJSONTyped,
    AtoNDefinitionScheduleInnerToJSON,
} from './AtoNDefinitionScheduleInner';

/**
 * 
 * @export
 * @interface AtoNDefinition
 */
export interface AtoNDefinition {
    /**
     * Whether the AtoN is autonomous
     * @type {boolean}
     * @memberof AtoNDefinition
     */
    autonomous?: boolean;
    /**
     * id of a pss used for chaining
     * @type {string}
     * @memberof AtoNDefinition
     */
    chainedaton?: string;
    /**
     * id of a pss used for chaining
     * @type {string}
     * @memberof AtoNDefinition
     */
    chained?: string;
    /**
     * Interval between broadcasts in seconds
     * @type {number}
     * @memberof AtoNDefinition
     */
    broadcastInterval?: number;
    /**
     * Description of the AtoN
     * @type {string}
     * @memberof AtoNDefinition
     */
    description?: string;
    /**
     * Whether the AtoN is enabled
     * @type {boolean}
     * @memberof AtoNDefinition
     */
    enabled?: boolean;
    /**
     * Seconds before a failure timeout is raised when AtoN is unresponsive
     * @type {number}
     * @memberof AtoNDefinition
     */
    failureTimeout?: number;
    /**
     * List of groups the AtoN is shared with
     * @type {Array<string>}
     * @memberof AtoNDefinition
     */
    groups?: Array<string>;
    /**
     * MMSI of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    mmsi?: number;
    /**
     * Name of AtoN
     * @type {string}
     * @memberof AtoNDefinition
     */
    name?: string;
    /**
     * Owner of AtoN
     * @type {string}
     * @memberof AtoNDefinition
     */
    owner?: string;
    /**
     * 
     * @type {AtoNDefinitionPosition}
     * @memberof AtoNDefinition
     */
    position?: AtoNDefinitionPosition;
    /**
     * List of PSS associated with the AtoN
     * @type {Array<string>}
     * @memberof AtoNDefinition
     */
    pss?: Array<string>;
    /**
     * Schedule for data collection of the AtoN
     * @type {Array<AtoNDefinitionScheduleInner>}
     * @memberof AtoNDefinition
     */
    schedule?: Array<AtoNDefinitionScheduleInner>;
    /**
     * Physical size in meters of dimension a of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    sizeA?: number;
    /**
     * Physical size in meters of dimension b of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    sizeB?: number;
    /**
     * Physical size in meters of dimension c of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    sizeC?: number;
    /**
     * Physical size in meters of dimension d of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    sizeD?: number;
    /**
     * Off position alarm. Can be note (0), warning (1) and alert (2)
     * @type {number}
     * @memberof AtoNDefinition
     */
    offPosAlarm?: number;
    /**
     * Type of AtoN
     * @type {number}
     * @memberof AtoNDefinition
     */
    type?: number;
    /**
     * UUID of AtoN
     * @type {string}
     * @memberof AtoNDefinition
     */
    uuid?: string;
    /**
     * Whether it is virtual (0) or synthetic (1)
     * @type {number}
     * @memberof AtoNDefinition
     */
    virtual?: AtoNDefinitionVirtualEnum;
    /**
     * Alarm setup
     * @type {Array<AtoNDefinitionAlarmSetupInner>}
     * @memberof AtoNDefinition
     */
    alarmSetup?: Array<AtoNDefinitionAlarmSetupInner>;
    /**
     * When to give timeout warning in seconds
     * @type {number}
     * @memberof AtoNDefinition
     */
    warningTimeout?: number;
    /**
     * State of aton, only set for physical's. (1 == ok, 2 == warning, 3 == failure)
     * @type {number}
     * @memberof AtoNDefinition
     */
    state?: number;
}


/**
 * @export
 */
export const AtoNDefinitionVirtualEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type AtoNDefinitionVirtualEnum = typeof AtoNDefinitionVirtualEnum[keyof typeof AtoNDefinitionVirtualEnum];


/**
 * Check if a given object implements the AtoNDefinition interface.
 */
export function instanceOfAtoNDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNDefinitionFromJSON(json: any): AtoNDefinition {
    return AtoNDefinitionFromJSONTyped(json, false);
}

export function AtoNDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoNDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autonomous': !exists(json, 'autonomous') ? undefined : json['autonomous'],
        'chainedaton': !exists(json, 'chainedaton') ? undefined : json['chainedaton'],
        'chained': !exists(json, 'chained') ? undefined : json['chained'],
        'broadcastInterval': !exists(json, 'broadcast_interval') ? undefined : json['broadcast_interval'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'failureTimeout': !exists(json, 'failure_timeout') ? undefined : json['failure_timeout'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'position': !exists(json, 'position') ? undefined : AtoNDefinitionPositionFromJSON(json['position']),
        'pss': !exists(json, 'pss') ? undefined : json['pss'],
        'schedule': !exists(json, 'schedule') ? undefined : ((json['schedule'] as Array<any>).map(AtoNDefinitionScheduleInnerFromJSON)),
        'sizeA': !exists(json, 'size_a') ? undefined : json['size_a'],
        'sizeB': !exists(json, 'size_b') ? undefined : json['size_b'],
        'sizeC': !exists(json, 'size_c') ? undefined : json['size_c'],
        'sizeD': !exists(json, 'size_d') ? undefined : json['size_d'],
        'offPosAlarm': !exists(json, 'off_pos_alarm') ? undefined : json['off_pos_alarm'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'virtual': !exists(json, 'virtual') ? undefined : json['virtual'],
        'alarmSetup': !exists(json, 'alarm_setup') ? undefined : ((json['alarm_setup'] as Array<any>).map(AtoNDefinitionAlarmSetupInnerFromJSON)),
        'warningTimeout': !exists(json, 'warning_timeout') ? undefined : json['warning_timeout'],
        'state': !exists(json, 'state') ? undefined : json['state'],
    };
}

export function AtoNDefinitionToJSON(value?: AtoNDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autonomous': value.autonomous,
        'chainedaton': value.chainedaton,
        'chained': value.chained,
        'broadcast_interval': value.broadcastInterval,
        'description': value.description,
        'enabled': value.enabled,
        'failure_timeout': value.failureTimeout,
        'groups': value.groups,
        'mmsi': value.mmsi,
        'name': value.name,
        'owner': value.owner,
        'position': AtoNDefinitionPositionToJSON(value.position),
        'pss': value.pss,
        'schedule': value.schedule === undefined ? undefined : ((value.schedule as Array<any>).map(AtoNDefinitionScheduleInnerToJSON)),
        'size_a': value.sizeA,
        'size_b': value.sizeB,
        'size_c': value.sizeC,
        'size_d': value.sizeD,
        'off_pos_alarm': value.offPosAlarm,
        'type': value.type,
        'uuid': value.uuid,
        'virtual': value.virtual,
        'alarm_setup': value.alarmSetup === undefined ? undefined : ((value.alarmSetup as Array<any>).map(AtoNDefinitionAlarmSetupInnerToJSON)),
        'warning_timeout': value.warningTimeout,
        'state': value.state,
    };
}

